(function (Namespace)
{
	/********************************************
	*
	* Start - Inputs
	*
	********************************************/

	Namespace.ScreenerUtility.Inputs = function ()
	{
		this._Data = {
			Arguments: [],
			Label: "",
			Name: "",
			ScreenerID: 0
		};

		this._Type = "Inputs";

		return this;
	}

	Namespace.ScreenerUtility.Inputs.fn = Namespace.ScreenerUtility.Inputs.prototype;

	Namespace.ScreenerUtility.Inputs.fn.Parse = function (Input, bFieldAndSafeNameAreTheSame)
	{
		if (!Input) { throw ("Error Occurred in Inputs.Parse(Input, bFieldAndSafeNameAreTheSame). Input can not be null. Please check your inputs and try again."); }

		// turn it into an object if you can.
		if (typeof (Input) == "string") { Input = JSON.parse(Input); }

		if (Input.Label)
		{
			this._Data.Label = Input.Label;
		}

		if (Input.Name)
		{
			this._Data.Name = Input.Name;
		}

		if (Input.ScreenerID)
		{
			this._Data.ScreenerID = Input.ScreenerID;
		}

		if (Input.Arguments)
		{
			this._Data.Arguments = [];

			for (var i = 0, j = Input.Arguments.length; i < j; i++)
			{
				var Arg = new Namespace.ScreenerUtility.Argument();

				Arg.Parse(Input.Arguments[i], bFieldAndSafeNameAreTheSame);

				this.AddArgument(Arg);
			}
		}

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.AddArgument = function (objArg)
	{
		// check if object and has secret type and then add the reference rather than just the data
		// that way we can remove things if need be.
		if (objArg && objArg._Type == "Argument")
		{
			this._Data.Arguments.push(objArg);
		}
		else
		{
			throw ("Error occured in ScreenerUtility.Inputs.AddArgument(objArg): Argument passed is not a valid ScreenerUtility.Argument. Please check your inputs and try again");
		}

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.RemoveArgumentByField = function (sFieldToRemove)
	{
		var arArgumentsToKeep = [];

		for (var i = 0; i < this._Data.Arguments.length; i++)
		{
			if (
				this._Data.Arguments[i]._SafeName != sFieldToRemove &&
				(this._Data.Arguments[i]._Data && this._Data.Arguments[i]._Data.Field != sFieldToRemove)
			)
			{
				arArgumentsToKeep.push(this._Data.Arguments[i]);
			}
		}

		this._Data.Arguments = arArgumentsToKeep;

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.RemoveArguments = function ()
	{
		this._Data.Arguments = [];

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.ContainsArgumentFor = function (sField)
	{
		return (this.GetArgument(sField) != null);
	};

	Namespace.ScreenerUtility.Inputs.fn.GetArgument = function (sField)
	{
		for (var i = 0; i < this._Data.Arguments.length; i++)
		{
			if (
				this._Data.Arguments[i]._SafeName == sField ||
				(this._Data.Arguments[i]._Data && this._Data.Arguments[i]._Data.Field == sField)
			)
			{
				return this._Data.Arguments[i];
			}
		}

		return null;
	};

	Namespace.ScreenerUtility.Inputs.fn.SetScreenerID = function (iScreenID)
	{
		this._Data.ScreenerID = iScreenID;

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.SetName = function (sName)
	{
		this._Data.Name = sName;

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.SetLabel = function (sLabel)
	{
		this._Data.Label = sLabel;

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.SetArguments = function (arArguments)
	{
		$.extend(true, this._Data.Arguments, arArguments);

		return this;
	};

	Namespace.ScreenerUtility.Inputs.fn.GetData = function ()
	{
		var ReturnData = {};

		$.extend(true, ReturnData, this._Data);

		ReturnData.Arguments = [];

		for (var i = 0, j = this._Data.Arguments.length; i < j; i++)
		{
			ReturnData.Arguments.push(this._Data.Arguments[i].GetData());
		}

		return ReturnData;
	};

	Namespace.ScreenerUtility.Inputs.fn.GetScreenerID = function ()
	{
		return this._Data.ScreenerID;
	};

	Namespace.ScreenerUtility.Inputs.fn.GetName = function ()
	{
		return this._Data.Name;
	};

	Namespace.ScreenerUtility.Inputs.fn.GetLabel = function ()
	{
		return this._Data.Label;
	};

	Namespace.ScreenerUtility.Inputs.fn.GetArguments = function (bGetDataOnly)
	{
		if (bGetDataOnly && this._Data.Arguments)
		{
			var arArgData = [];

			for (var i = 0, j = this._Data.Arguments.length; i < j; i++)
			{
				arArgData.push(this._Data.Arguments[i]._Data);
			}

			return arArgData;
		}

		return this._Data.Arguments;
	};

	/********************************************
	*
	* End - Inputs
	*
	********************************************/

	/*****************************************************************/

	/********************************************
	*
	* Start - ScreenInputs
	*
	********************************************/

	Namespace.ScreenerUtility.ScreenInputs = function ()
	{
		Namespace.ScreenerUtility.ScreenInputs.Super(this);

		var LocalInitData = {
			FirstRow: 0,
			RowCount: 10,
			ResultFields: [],
			SortArguments: []
		};

		$.extend(true, this._Data, LocalInitData);

		this._Type = "ScreenInputs";

		return this;
	};

	// Extend the Inputs class
	Namespace.ScreenerUtility.ScreenInputs.Extend(Namespace.ScreenerUtility.Inputs);

	Namespace.ScreenerUtility.ScreenInputs.fn = Namespace.ScreenerUtility.ScreenInputs.prototype;

	Namespace.ScreenerUtility.ScreenInputs.fn.Parse = function (Input, bFieldAndSafeNameAreTheSame)
	{
		Namespace.ScreenerUtility.ScreenInputs.Super(this, "Parse", [Input, bFieldAndSafeNameAreTheSame]);

		// turn it into an object if you can.
		if (typeof (Input) == "string") { Input = JSON.parse(Input); }

		if (Input.FirstRow)
		{
			this._Data.FirstRow = Input.FirstRow;
		}

		if (Input.RowCount)
		{
			this._Data.RowCount = Input.RowCount;
		}

		if (Input.ResultFields)
		{
			this._Data.ResultFields = Input.ResultFields;
		}

		if (Input.SortArguments)
		{
			this._Data.SortArguments = [];

			for (var i = 0, j = Input.SortArguments.length; i < j; i++)
			{
				var passedArgData = Input.SortArguments[i];
				var SortArg = new Namespace.ScreenerUtility.ScreenInputs.SortArgument(passedArgData.Field, passedArgData.Direction);
				this.AddSortArgument(SortArg);
			}
		}
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.SetFirstRow = function (iFirstRow)
	{
		this._Data.FirstRow = iFirstRow;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.SetRowCount = function (iRowCount)
	{
		this._Data.RowCount = iRowCount;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.SetResultFields = function (arResultFields)
	{
		if (arResultFields)
		{
			this._Data.ResultFields = arResultFields;
		}

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.GetResultFields = function ()
	{
		return this._Data.ResultFields;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.AddResultField = function (sField)
	{
		this._Data.ResultFields.push(sField);

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.RemoveResultField = function (sFieldToRemove)
	{
		var arFieldsToKeep = [];

		for (var i = 0, j = this._Data.ResultFields.length; i < j; i++)
		{
			if (this._Data.ResultFields[i] != sFieldToRemove)
			{
				arFieldsToKeep.push(this._Data.ResultFields[i]);
			}
		}

		this._Data.ResultFields = arFieldsToKeep;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.RemoveResultFieldAt = function (iIndex)
	{
		this._Data.ResultFields.splice(iIndex, 1);

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.SetSortArguments = function (arSortArguments)
	{
		this._Data.SortArguments = arSortArguments;
		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.GetSortArguments = function ()
	{
		return this._Data.SortArguments;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.AddSortArgument = function (SortArgument)
	{
		if (!SortArgument || SortArgument._Type != "SortArgument")
		{
			throw ("Error occured in AddSortArgument(SortArgument): SortArgument cannot be null and must be of type Namespace.ScreenerUtility.ScreenInputs.SortArgument");
		}

		this._Data.SortArguments.push(SortArgument);

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.RemoveSortArgument = function (sFieldToRemove)
	{
		var arArgumentsToKeep = [];

		for (var i = 0, j = this._Data.SortArguments.length; i < j; i++)
		{
			if (this._Data.SortArguments[i].Field != sFieldToRemove)
			{
				arArgumentsToKeep.push(this._Data.SortArguments[i]);
			}
		}

		this._Data.SortArguments = arArgumentsToKeep;

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.RemoveSortArgumentAt = function (iIndex)
	{
		this._Data.SortArguments.splice(iIndex, 1);

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.RemoveSortArguments = function ()
	{
		this._Data.SortArguments = [];

		return this;
	};

	Namespace.ScreenerUtility.ScreenInputs.fn.GetData = function ()
	{
		var DataToReturn = {};

		// make a new instance of all the data we already have
		$.extend(true, DataToReturn, this._Data);

		// call the base GetData Method
		var BaseReturn = Namespace.ScreenerUtility.ScreenInputs.Super(this, "GetData", arguments);

		// update the properties in DataToReturn with the information in BaseReturn
		$.extend(true, DataToReturn, BaseReturn);

		// reset sort arguments because we want to grab the data for each item.
		DataToReturn.SortArguments = [];

		// loop through all the sort arguments and get the data we need and push that into our sort arguments
		// so we can send back an array of everything we really need.
		for (var i = 0, j = this._Data.SortArguments.length; i < j; i++)
		{
			DataToReturn.SortArguments.push(this._Data.SortArguments[i].GetData());
		}

		return DataToReturn;
	};

	/********************************************
	*
	* End - ScreenInputs
	*
	********************************************/

})(window.MOD || window.WSOD || window);